// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__2NpXQ","label":"Section_label__30ETB","contentWrap":"Section_contentWrap__3sU6R","footer":"Section_footer__1XYHU","footerInner":"Section_footerInner__iyKvO"};